import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const MockupHealth = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../../images/health_feature.png"
      alt="collar inteligente Kolyy"
    />
  );
};

export default MockupHealth;
